import React, { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import {
  CircularProgress,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  MenuItem,
  TextField,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  DialogContentText,
  DialogActions,
  FormControlLabel,
  Card,
  CardContent,
  Divider,
  Typography,
  Tooltip,
} from "@mui/material";
import { Edit, Delete, More } from "@mui/icons-material";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import CaseForm from "./CaseForm";
import moment from "moment";
import AutohideSnackbar from "../LayoutModule/autohideSnackbar";
import AppGlobalStaticData from "../../appdata/appStaticData";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import useCaseAPIDetails from "../../api/caseAPIDetails"; //
import useCourtAPIDetails from "../../api/courtAPIDetails"; //
import PageContentLayout from "../LayoutModule/pageContentLayout";

const columnOptions = [
  { value: "fileNo", label: "File No" },
  { value: "caseNo", label: "Case No" },
  { value: "IANo", label: "IA No" },
  { value: "CNRNo", label: "CNR No" },
  { value: "clientName", label: "Client Name" },
  { value: "appearingFor", label: "Appearing For" },
  { value: "mobile", label: "Mobile" },
  { value: "mobile2", label: "Mobile 2" },
  { value: "prevDate", label: "Prev Date" },
  { value: "nextDate", label: "Next Date" },
  { value: "status", label: "Status" },
];


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

const CaseList = ({ Type, startdate, enddate, casestatusParam, pageName }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteId, setDeleteID] = useState(0);
  const [selectedcaseId, setSelectedcaseId] = useState(null);
  const [groupedCourts, setGroupedCourts] = useState({});
  const [casestatus, setCaseStatus] = useState(casestatusParam || []);
  const [caseStatusDropDown, setCaseStatusDropdown] = useState(0);
  const [snackbarProperties, setSnackbarProperties] = useState({
    duration: 0,
    message: "",
    serverity: "",
  });
  const [totalCases, setTotalCases] = useState(0);
  const [casesList, setCasesList] = useState([]);
  const { fetchCaseListData, deleteData } = useCaseAPIDetails();

  const { courtList, fetchCourtsList } = useCourtAPIDetails();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const caseStatusAPILoading = useRef(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (snackbarProperties.message) {
      setSnackbarOpen(true);
    }
  }, [snackbarProperties.message]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  //const [endDate, setEndDate] = useState(enddate || "");

  const [filters, setFilters] = useState({
    startDate: startdate,
    endDate: enddate,
    courtFilter: "",
    searchFilter: "",
    courtPlaceFilter: "",
  });

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });

  const [selectedColumns, setSelectedColumns] = useState(
    columnOptions.map((option) => option.value)
  );
  const globalData = new AppGlobalStaticData();
  const caseStatusList = [
    { id: 0, name: "select" },
    { id: 1, name: "Disposed" },
    { id: 2, name: "Decreed" },
  ];
  useEffect(() => {
    //setEndDate(enddate);
    handleFilterChange("endDate",enddate );
    setCaseStatus(casestatusParam);

  }, [Type, casestatusParam, enddate]);

  useEffect(() => {
    const fetchData = async () => {
      caseStatusAPILoading.current = true;
      
      await fetchCaseList();
      if (Type === "List" || Type === "Edit") {
        await fetchCourts();
      }
      caseStatusAPILoading.current = false;
    };

    if (!loading) {
      if (
        (Type === "Edit" && filters.endDate) ||
        Type === "List" ||
        Type === "Disposed-Decreed"
      ) {
        if (!caseStatusAPILoading.current) {
          fetchData();
        }
      }
    }
  }, [Type, paginationModel]);

  const fetchCaseList = async () => {
    setLoading(true);
    try {
      const caseList = await fetchCaseListData(
        filters,
        casestatus,
        paginationModel
      );

      if (!caseList || !caseList.data || caseList.data.length === 0) {
        setSnackbarProperties({
          duration: globalData.Duration,
          message: globalData.CaseListNotAvailable,
          severity: globalData.SeverityError, // Fixed typo
        });
        return;
      }

      // Add serial number (sno) to each case
      const caseListWithSno = caseList.data.map((item, index) => ({
        id: item.id,
        sno: paginationModel.page * paginationModel.pageSize + index + 1,
        ...item,
      }));

      setCasesList(caseListWithSno);
      setTotalCases(caseList.total);

      setSnackbarProperties({
        duration: globalData.Duration,
        message: globalData.CaseListSuccess,
        severity: globalData.SeveritySuccess,
      });
    } catch (error) {
      console.error("Error fetching cases:", error);
      setSnackbarProperties({
        duration: globalData.Duration,
        message: globalData.CaseListFailed,
        severity: globalData.SeverityError,
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchCourts = async () => {
    setLoading(true);
    fetchCourtsList().then((courtList) => {
      if (!courtList || courtList.length == 0) {
        setSnackbarProperties({
          duration: globalData.Duration,
          message: globalData.CourtListFailed,
          serverity: globalData.SeverityError,
        });
      } else {
        const grouped = courtList.reduce((acc, court) => {
          if (!acc[court.Place]) {
            acc[court.Place] = [];
          }
          acc[court.Place].push(court);
          return acc;
        }, {});
        setGroupedCourts(grouped);
      }
    });
    setLoading(false);
  };

  const handleOpen = (id) => {
    setSelectedcaseId(null);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedcaseId(null);
    fetchCaseList();
  };

  const handleEdit = (id) => {
    setSelectedcaseId(id);
    setOpen(true);
  };

  const handleDetailsPage = (id) => {
    navigate(`/case/details/${id}`);
  };

  const handleDeletePopup = async () => {
    await handleDelete(deleteId);
    setDeleteOpen(false);
  };

  const handleDeletePopupOpen = async (id) => {
    //await handleDelete(id);
    setDeleteOpen(true);
    setDeleteID(id);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    const success = await deleteData(id);
    if (success) {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: success
          ? globalData.DeleteCaseSuccess
          : globalData.DeleteCaseFailed,
        serverity: success
          ? globalData.SeveritySuccess
          : globalData.SeverityError,
      });
      await fetchCaseList(); // Refresh case list only if deletion is successful
    } else {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: globalData.DeleteCaseFailed,
        serverity: globalData.SeverityError,
      });
    }
    setLoading(false);
  };

  const handlePaginationModelChange = (model) => {
    setPaginationModel((prevModel) => ({
      ...prevModel,
      page: model.page,
      pageSize: model.pageSize,
    }));
  };

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleFilterSubmit = () => {
    fetchCaseList();
  };

  const handleColumnChange = (event) => {
    setSelectedColumns(event.target.value);
  };
  const handleSearchChange = useCallback((e) => {
    console.log(e.target.value);
    handleFilterChange("searchFilter", e.target.value);
    // if (inputRef.current) {
    //   inputRef.current.focus();
    // }
  }, []);

  const handleCaseStatusDropDown = (e) => {
    setCaseStatusDropdown(e.target.value);
    if (e.target.value === 0) {
      setCaseStatus([1, 2]);
    } else {
      setCaseStatus([e.target.value]);
    }
  };

  const handleDownloadDocument = async () => {
    try {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: globalData.DownloadStarted,
        serverity: globalData.SeverityInfo,
      });

      const token = Cookies.get("auth_token");
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/case-details/download`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            start_date: filters.startDate
              ? moment(filters.startDate).format("YYYY-MM-DD")
              : startdate
              ? moment(startdate).format("YYYY-MM-DD")
              : undefined,
            end_date: filters.endDate
              ? moment(filters.endDate).format("YYYY-MM-DD")
              : undefined,
            court_id: filters.courtFilter,
            court_place: filters.courtPlaceFilter,
            api_token: API_TOKEN,
            columns: selectedColumns,
            case_status: JSON.stringify(casestatus),
          },
          responseType: "blob", // Important to handle binary data
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "case_details.docx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setSnackbarProperties({
          duration: globalData.Duration,
          message: globalData.DownloadSuccess,
          serverity: globalData.SeveritySuccess,
        });
      } else {
        setSnackbarProperties({
          duration: globalData.Duration,
          message: globalData.DownloadFailed,
          serverity: globalData.SeverityError,
        });
        console.error("Failed to download document:", response.statusText);
      }
    } catch (error) {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: globalData.DownloadFailed,
        serverity: globalData.SeverityError,
      });
      if (error.response) {
        console.error("Server Error:", error.response.data);
      } else if (error.request) {
        console.error("Network Error:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  const columns = [
    { field: "sno", headerName: "S.No", width: 50, sortable: false },
    { field: "fileNo", headerName: "File No", width: 150 },
    { field: "caseNo", headerName: "Case No", width: 100 },
    { field: "IANo", headerName: "IANO", width: 100 },
    { field: "CNRNo", headerName: "CNR No", width: 100 },
    { field: "clientName", headerName: "Client Name", width: 150 },
    { field: "appearingFor", headerName: "Appearing For", width: 150 },
    { field: "mobile", headerName: "Mobile 1", width: 130 },
    { field: "mobile2", headerName: "Mobile 2", width: 130 },
    {
      field: "caseStatus",
      headerName: "case Status",
      width: 150,
      valueFormatter: (params) => (params === 1 ? "Disposed" : "Decreed"),
    },
    {
      field: "prevDate",
      headerName: "Prev Date",
      width: 100,
      valueFormatter: (params) => formatDate(params),
    },
    {
      field: "nextDate",
      headerName: "Next Date",
      width: 100,
      valueFormatter: (params) => formatDate(params),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton
            onClick={() => handleDetailsPage(params.id)}
            color="primary"
          >
            <More />
          </IconButton>
          <IconButton onClick={() => handleEdit(params.id)} color="primary">
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => handleDeletePopupOpen(params.id)}
            color="secondary"
          >
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];

  const filteredColumns =
    Type === "Disposed-Decreed"
      ? columns.filter(
          (col) =>
            !["IANo", "appearingFor", "prevDate", "nextDate,mobile2"].includes(
              col.field
            )
        )
      : columns.filter((col) => !["caseStatus"].includes(col.field));

  const CourtFilter = () => {
    return (
      <>
        <Grid item xs={12} sm={3}>
          <TextField
            select
            label="Court Place"
            value={filters.courtPlaceFilter}
            onChange={(e) =>
              handleFilterChange("courtPlaceFilter", e.target.value)
            }
            fullWidth
            margin="normal"
          >
            {Object.keys(groupedCourts).map((courtPlace) => (
              <MenuItem key={courtPlace} value={courtPlace}>
                {courtPlace}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Court Name Filter */}
        <Grid item xs={12} sm={3}>
          <TextField
            select
            label="Court Name"
            value={filters.courtFilter}
            onChange={(e) => handleFilterChange("courtFilter", e.target.value)}
            fullWidth
            margin="normal"
            disabled={!filters.courtPlaceFilter}
          >
            {filters.courtPlaceFilter &&
              groupedCourts[filters.courtPlaceFilter].map((court) => (
                <MenuItem key={court.id} value={court.id}>
                  {court.CourtName}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
      </>
    );
  };

  const DateFilter = () => {
    return (
      <>
        {/* Start Date Picker */}
        <Grid item xs={12} sm={2}>
          <DatePickerComponent
            placeholder="Start Date"
            value={filters.startDate}
            onChange={(e) => handleFilterChange("startDate", e.target.value)}
            format="dd/MM/yyyy"
            style={{ width: "100%" }}
          />
        </Grid>

        {/* End Date Picker */}
        <Grid item xs={12} sm={2}>
          <DatePickerComponent
            placeholder="End Date"
            value={filters.endDate}
            onChange={(e) => { handleFilterChange("endDate",e.target.value )}}
            format="dd/MM/yyyy"
            style={{ width: "100%" }}
          />
        </Grid>
      </>
    );
  };

  const ApplyFilter = () => {
    return (
      <>
        {/* Apply Filters Button */}
        <Grid item xs={12} sm={2} display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilterSubmit}
            fullWidth
            style={{ marginTop: "8px" }}
          >
            Apply Filters
          </Button>
        </Grid>
      </>
    );
  };

  const DownloadColumOption = () => {
    return (
      <>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth margin="normal">
            <Select
              multiple
              value={selectedColumns}
              onChange={handleColumnChange}
              renderValue={(selected) => selected.join(", ")}
            >
              {columnOptions.map((column) => (
                <MenuItem key={column.value} value={column.value}>
                  <Checkbox
                    checked={selectedColumns.indexOf(column.value) > -1}
                  />
                  <ListItemText primary={column.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </>
    );
  };

  const DownloadButton = () => {
    return (
      <>
        <Grid item xs={12} sm={2} display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDownloadDocument}
            fullWidth
          >
            Download
          </Button>
        </Grid>
      </>
    );
  };

  const CreateButton = () => {
    return (
      <>
        <Grid item xs={12} sm={2} display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleOpen(null)}
            fullWidth
          >
            Create Case
          </Button>
        </Grid>
      </>
    );
  };

  const SearchButton = () => {
    return (
      <>
        <Grid item xs={12} sm={3}>
          <input
            type="search"
            placeholder="Search..."
            defaultValue={filters.searchFilter}
            onBlur={handleSearchChange}
            style={{
              padding: "16.5px 14px",
              border: "1px solid rgba(0, 0, 0, 0.87)",
              borderRadius: "4px",
              width: "100%",
              minHeight: "1.4375em",
              marginTop: "16px",
              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
              color: "rgba(0, 0, 0, 0.87)",
              fontSize: "16px",
            }}
          />
        </Grid>
      </>
    );
  };

  const GridFilterElement = () => {
    if (Type === "List") {
      return (
        <>
          <Grid container spacing={4} alignItems="center" mb={2}>
            {/* Court Place Filter */}
            <CourtFilter />
            <DateFilter />
            <ApplyFilter />
          </Grid>

          {/* Additional Filters Row */}
          <Grid container spacing={4} alignItems="center" mb={2}>
            {/* Column Selection  download option*/}
            <DownloadColumOption />
            <SearchButton />
            <DownloadButton />
            {/* <CreateButton /> */}
          </Grid>
        </>
      );
    } else if (Type === "Edit") {
      return (
        <>
          <Grid container spacing={4} alignItems="center" mb={2}>
            {/* Court Place Filter */}
            <CourtFilter />
            <SearchButton />
            <ApplyFilter />
          </Grid>
          <Grid container spacing={4} alignItems="center" mb={2}>
            {/* Column Selection  download option*/}
            <DownloadColumOption />

            <DownloadButton />
          </Grid>
        </>
      );
    }
  };

  const CaseStatusDropDownUI = () => {
    if (Type === "Disposed-Decreed") {
      return (
        <>
          <Grid item xs={12} sm={3}>
            <TextField
              select
              label="Case status List"
              value={caseStatusDropDown}
              onChange={handleCaseStatusDropDown}
              fullWidth
              margin="normal"
            >
              {caseStatusList.map((item, index) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </>
      );
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <PageContentLayout
      pageName={pageName}
      addcallbackFunction={() => handleOpen(null)}
      tooltip="Add Case"
    >
      <Box
        sx={{
          background: "#E3EAF0",
          padding: 3,
          margin: 3,
          borderRadius: "8px",
          boxShadow: "0px 4px 8px rgba(170, 64, 64, 0.1)",
        }}
      >
        <GridFilterElement />
        <CaseStatusDropDownUI />
      </Box>
      <div style={{ height: "auto", width: "100%", margin: "auto" }}>
        <DataGrid
          rows={casesList}
          columns={filteredColumns}
          pageSizeOptions={[10, 25, 50, 100]} // Add 100 as an option
          pageSize={paginationModel} // Set the default page size to 100
          rowCount={totalCases}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          loading={loading}
        />
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          {selectedcaseId ? "Edit Case" : "Create Case"}
        </DialogTitle>
        <DialogContent>
          <CaseForm
            id={selectedcaseId}
            onClose={handleClose}
            Type={Type}
            caseStatusList={caseStatusList}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to delete this record? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeletePopup} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <AutohideSnackbar
        open={snackbarOpen}
        duration={snackbarProperties.duration}
        message={snackbarProperties.message}
        severity={snackbarProperties.serverity}
        handleClose={handleSnackbarClose}
      ></AutohideSnackbar>
    </PageContentLayout>
  );
};

export default CaseList;
